import { render, staticRenderFns } from "./DgBaseDatepickerCalendar.vue?vue&type=template&id=8c50f620&"
import script from "./DgBaseDatepickerCalendar.vue?vue&type=script&lang=js&"
export * from "./DgBaseDatepickerCalendar.vue?vue&type=script&lang=js&"
import style0 from "./DgBaseDatepickerCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports